import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import Image from 'gatsby-image'
import Swiper from 'react-id-swiper'
import { desktopBreakpoint, desktopVw, mobileVw, colors } from '../../styles'
import { Arrow } from '../shared/icons'

import 'swiper/css/swiper.css'

export const RecipeHero = (props) => {
  const [swiper, updateSwiper] = useState(null)
  const [activeSlide, setActiveSlide] = useState(0)

  const params = {
    getSwiper: updateSwiper,
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 30,
  }

  const slideTo = (i) => {
    if (swiper !== null) {
      swiper.slideTo(i)
      setActiveSlide(i)
    }
  }

  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext()
    }
  }
  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev()
    }
  }

  useEffect(() => {
    if (swiper !== null) {
      setActiveSlide(swiper.activeIndex)
    }
  }, [swiper, activeSlide])

  return (
    <SwiperWrapper>
      <MainImageWrapper>
        <Swiper {...params}>
          {props.images.map((image, i) => (
            <Image key={i} fluid={image.fluid} alt={image.title} />
          ))}
        </Swiper>
        {props.children}
      </MainImageWrapper>
      {props.images.length > 1 ? (
        <NavigationWrapper>
          <Button type='submit' onClick={() => goPrev()}>
            <StyledArrow />
          </Button>
          <Button type='submit' onClick={() => goNext()}>
            <StyledArrow />
          </Button>
        </NavigationWrapper>
      ) : null}
      <ThumbnailsWrapper display={props.images.length > 1}>
        {props.images.map((image, i) => (
          <Button key={i} onClick={() => slideTo(i)} active={i === activeSlide}>
            <Image fluid={image.fluid} alt={image.title} />
          </Button>
        ))}
      </ThumbnailsWrapper>
    </SwiperWrapper>
  )
}

const StyledArrow = styled(Arrow)`
  width: ${desktopVw(15)};
  height: auto;
  stroke: ${colors.white};
`

const SwiperWrapper = styled.div`
  padding: ${mobileVw(8)} ${mobileVw(16)};
  display: flex;
  flex-direction: column;
  position: relative;

  @media (min-width: ${desktopBreakpoint}) {
    padding: 0;
    flex-direction: row;
    height: 35vw;
  }
`

const NavigationWrapper = styled.div`
  background-color: ${colors.mailleGold};
  position: absolute;
  bottom: ${mobileVw(56)};
  right: ${mobileVw(16)};
  display: flex;
  z-index: 2;
  svg {
    width: auto;
  }
  button {
    cursor: pointer;
    &:first-of-type {
      svg {
        transform: rotate(180deg);
      }
    }
  }

  @media (min-width: ${desktopBreakpoint}) {
    right: ${desktopVw(95)};
    bottom: 0;
  }
`

const MainImageWrapper = styled.div`
  position: relative;
  .swiper-container {
    width: 100%;
    height: ${mobileVw(320)};
    margin: ${mobileVw(0)} auto ${mobileVw(8)};

    @media (min-width: ${desktopBreakpoint}) {
      width: 40vw;
      height: 100%;
      z-index: 1;
    }
  }
`

const ThumbnailsWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: ${(props) => (props.display ? 'flex' : 'none')};
  flex-direction: row;

  @media (min-width: ${desktopBreakpoint}) {
    display: flex;
    flex-direction: column;
    padding: ${desktopVw(32)} 0 0 ${desktopVw(30)};
  }
`

const Button = styled.button`
  padding: 0;
  margin-right: ${mobileVw(8)};
  height: ${mobileVw(40)};
  width: ${mobileVw(40)};
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: ${desktopBreakpoint}) {
    width: ${desktopVw(64)};
    height: ${desktopVw(64)};
    margin-bottom: ${desktopVw(17)};
    margin: 0;
  }
`
